import type { VkPixelPushData } from '~/types/vkPixel'

const useVkPixel = (pixelId?: string) => {
  const vkPush = (data: VkPixelPushData) => {
    window._tmr && (window._tmr = window._tmr || []).push(data)
  }

  const viewProduct = (productPrice: string, productId: number) => {
    pixelId &&
      vkPush({
        type: 'reachGoal',
        id: pixelId,
        value: productPrice,
        goal: 'viewProduct',
        params: {
          product_id: productId,
        },
      })
  }

  const addToCart = (ticketPrice: string, productId: number) => {
    pixelId &&
      vkPush({
        type: 'reachGoal',
        id: pixelId,
        value: ticketPrice,
        goal: 'addToCart',
        params: {
          product_id: productId,
        },
      })
  }

  const purchase = (orderPrice: string, productId: number) => {
    pixelId &&
      vkPush({
        type: 'reachGoal',
        id: pixelId,
        value: orderPrice,
        goal: 'purchase',
        params: {
          product_id: productId,
        },
      })
  }

  return {
    viewProduct,
    addToCart,
    purchase,
  }
}

export { useVkPixel }
